import { createDetailReducer } from '../../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'BRIEF',
  inside: {
    article: { get: 'briefs', set: 'brief' },
  },
});
